import {
  pageListRequestLimit,
  requestLimit
} from '../../../constants/configs';

export const buildQrDataUrl = ({ baseUrl, page, isMePage, limit, search }) => {
  const endpoint = isMePage ? '/page/user-page-pagination' : '/entry/list';
  const requestPageLimit =
    limit ?? (isMePage ? pageListRequestLimit : requestLimit);

  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';

  return `${baseUrl}${endpoint}?page=${page}&limit=${requestPageLimit}${searchParam}`;
};

export const mergePageItems = (currentItems, nextItems, page) => {
  if (page === 1) return nextItems;

  const existingIds = new Set(currentItems.map((item) => item.entryId));

  return [
    ...currentItems,
    ...nextItems.filter((item) => !existingIds.has(item.entryId))
  ];
};

export const shouldLoadNextPage = ({
  isMePage,
  loading,
  currentPage,
  maxPage,
  scrollHeight,
  scrollTop,
  clientHeight
}) =>
  isMePage &&
  !loading &&
  currentPage < maxPage &&
  scrollHeight - scrollTop - clientHeight < 24;
